var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounQuestion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-question-5179459",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291896",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291896",
    d: "M120.5,112.5a8.009,8.009,0,1,0,5.654,2.346A8,8,0,0,0,120.5,112.5Zm0,14.769a6.777,6.777,0,1,1,4.784-1.985A6.769,6.769,0,0,1,120.5,127.269Z",
    transform: "translate(-112.5 -112.5)",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291897",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291897",
    d: "M440.65,337.425a2.668,2.668,0,0,0-3.145,2.626.615.615,0,1,0,1.231,0,1.437,1.437,0,1,1,1.983,1.328,1.928,1.928,0,0,0-1.163,1.805v.629a.615.615,0,1,0,1.231,0v-.629a.709.709,0,0,1,.4-.665,2.667,2.667,0,0,0-.539-5.087Z",
    transform: "translate(-432.172 -333.692)",
    fill: "gray"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291898",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291898",
    d: "M558.935,791.65a.684.684,0,1,0,.484.2A.684.684,0,0,0,558.935,791.65Z",
    transform: "translate(-550.935 -780.505)",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounQuestion);
export default __webpack_public_path__ + "static/media/noun-question.b3f54eb6376cfceebff9bbc15f5a1b7c.svg";
export { ForwardRef as ReactComponent };